module.exports = __webpack_public_path__ + "static/media/machine-handler-active.c6923af5.png";